import { Injectable } from '@angular/core';
import { UserContextTO } from '../../store/session/user-context/user-context.interface';
import { RestService } from './rest.service';

@Injectable({ providedIn: 'root' })
export class UserContextRestService {
  constructor(private restService: RestService) {
  }

  getUserContext(): Promise<UserContextTO> {
    return this.restService.get$$<UserContextTO>('/User/context');
  }
}
